import { Button } from 'ui';
import React from 'react';

import { CollectionSummary } from './rowSummaryTypes';
import { useNavigate } from 'react-router-v7';

interface EditCollectionButtonProps {
  collectionSummary: CollectionSummary;
  geographyId: string;
  disabled?: boolean;
}

const EditCollectionButton: React.FC<EditCollectionButtonProps> = ({
  collectionSummary,
  geographyId,
  disabled,
}) => {
  const navigate = useNavigate();
  return (
    <Button
      size="small"
      disabled={disabled}
      onClick={() =>
        navigate(
          `/jce-homepage-geography/${geographyId}/collections/${collectionSummary.id}/edit`,
          {
            state: {
              name: collectionSummary.name,
              shortName: collectionSummary.shortName ?? '',
              description: collectionSummary.description ?? '',
              iconIndicator: collectionSummary.iconIndicator ?? 'ICON_UNSPECIFIED',
              status: collectionSummary.status ?? 'DRAFT',
              urlSlug: collectionSummary.urlSlug ?? '',
              collectionEntrys: collectionSummary.collectionEntrys ?? [],
            },
          }
        )
      }
    >
      Edit
    </Button>
  );
};

export default EditCollectionButton;
